export default __webpack_public_path__ + "static/media/logo-no-bg.943961f3.png";